import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Typography } from "@mui/material";
import clsx from "clsx";
import { FC } from "react";
import { DesktopStepIconProps } from "../lib/type";
import { DesktopStepIconRenderer } from "./DesktopStepIconRenderer";

export const DesktopStepIcon: FC<DesktopStepIconProps> = ({
  stepNumber,
  completed,
  active,
  percent = 0,
  className,
}) => {
  return (
    <div
      className={cn(
        "relative h-11 w-11 justify-center flex-center-row",
        className,
      )}
    >
      <DesktopStepIconRenderer
        completed={completed}
        active={active}
        percent={percent}
      />
      {!completed && (
        <div className={"absolute"}>
          <Typography
            className={clsx({
              "text-white": active,
              "text-bulish-gray": !active,
            })}
          >
            {stepNumber}
          </Typography>
        </div>
      )}
    </div>
  );
};
